'use client'
import Image from 'next/image'

import { PrismicLink } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'
import { getLangPath } from '@/utils/getLangFormat'
import { useTranslation } from '@/hooks/useTranslation'
import NavbarChevronRight from '@/components/navbar/NavbarChevronRight'

import { useLocale } from '@/context/LocaleContext'

const SolutionsDropdownData = ({ data }: { data: any }) => {
  const locale = useLocale()
  const { t } = useTranslation(locale)
  const getFrameworksPath = (locale: string) => `/${getLangPath(locale)}/frameworks`

  return (
    <div className="dropdown-menu">
      <div className="container-fluid">
        <div className="dropdown-menu-wrapper">
          <div className="solutions-nav-content">
            <h4 className="mb-6">{data.solutions_text}</h4>

            <div className="solutions-nav-content-items">
              {(data.solutions ?? []).map((item: any, index: number) => {
                const key = `i-${index}`
                return (
                  <div key={key} className="solutions-nav-content-item">
                    <PrismicNextImage field={item.logo} loading="lazy" fallbackAlt="" />

                    <div className="mb-14 mt-[10px] flex flex-col gap-1">
                      <span className="block font-halyardDisplay text-base font-medium !leading-[110%] tracking-[0.16px] !text-primary-ink-100">
                        {item.solutions_title}
                      </span>
                      <span className="block min-h-[70px] text-base font-normal !leading-[150%] tracking-[0.16px] text-primary-ink-85">
                        {item.solutions_description}
                      </span>
                    </div>

                    <PrismicLink field={item.solutions_learn_more_btn_link}>
                      <div className="btn-interaction flex items-center gap-2 leading-none">
                        <span className="font-halyardDisplay text-base font-medium tracking-[0.16px] text-primary-ink-100">
                          {item.solutions_learn_more_btn_label}
                        </span>
                        <NavbarChevronRight />
                      </div>
                    </PrismicLink>
                  </div>
                )
              })}
            </div>
          </div>

          <div className="top-frameworks-nav-content">
            <h4 className="mb-6">{data.top_frameworks_text}</h4>

            <div className="top-frameworks-nav-content-items">
              {(data.top_frameworks ?? []).map((item: any, index: number) => {
                const key = `i-${index}`
                return (
                  <PrismicLink field={item.top_frameworks_link_url} key={key}>
                    <div className="top-frameworks-nav-content-item">
                      <div className="flex flex-col gap-1">
                        <span className="block font-halyardDisplay text-base font-medium !leading-[110%] tracking-[0.16px] text-primary-ink-100">
                          {item.top_frameworks_title}
                        </span>
                        <span className="block text-base font-normal !leading-[150%] tracking-[0.16px] text-primary-ink-85">
                          {item.top_frameworks_description}
                        </span>
                      </div>
                    </div>
                  </PrismicLink>
                )
              })}
            </div>

            <PrismicLink
              href={locale === 'en-us' ? '/frameworks' : getFrameworksPath(locale)}
              className="btn btn-primary btn-default btn-interaction mt-6 !w-fit">
              {t('see_all_frameworks')}
              <Image src="/images/angle-right-green.svg" width={20} height={16} alt="angle-right" loading="lazy" />
            </PrismicLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SolutionsDropdownData
